import {CompetitionPowerRanking} from '../resources/CompetitionPowerRanking';
import {DomainEvent} from './DomainEvent';

export class PowerRankingCreated extends DomainEvent<CompetitionPowerRanking> {}
